import { useCrmObjectType } from 'framework-listing-lib/internal/providers/CrmObjectTypeListingClientProvider';
export default function useFetcher() {
  "use memo";

  const {
    fetcher
  } = useCrmObjectType();
  return fetcher;
}
export function useHasCustomFetcher() {
  "use memo";

  const fetcher = useFetcher();
  return Boolean(fetcher);
}